import { Input, Form } from 'antd';
import { ml } from 'src/_shared/services/utils';
import Spinner from 'src/_shared/components/spinner/SpinnerComponent.jsx';
import ReferralTiers from './ReferralTiersComponent.jsx';

export function TieredBonus(props) {
	const {
		currentUser,
		allMultiLingualData,
		bonusId,
		name,
		tiers,
		onChange,
		submitting,
		theme,
		company,
		form
	} = props;


	return submitting ? (
		<Spinner company={company} />
	) : (
		<Form form={form}>
			<div className="bs-form">
				<div className="custom-form-group">
					<h6 className="bs-form-label">
						<span className="required">*</span> {ml('Bonus Name', currentUser, allMultiLingualData)}
					</h6>
					<Form.Item
						name={`tieredBonus-${bonusId}`}
						rules={[{ required: true, message: 'Enter bonus name' }]}
						initialValue={name}
					>
						<Input
							className="custom-input"
							placeholder="ex. Level One"
							onChange={onChange}
						/>
					</Form.Item>
				</div>
				<ReferralTiers
					currentUser={currentUser}
					allMultiLingualData={allMultiLingualData}
					theme={theme}
					tierKeyBase={bonusId}
					currentTiers={tiers}
					userGroups={props.userGroups}
					userGroup={props.userGroup}
					updateExclusions={props.updateExclusions}
					updateInclusions={props.updateInclusions}
					form={form}
				/>
			</div>
		</Form>
	);
}
